import closeIcon from '@iconify/icons-ant-design/close-outline';
import { IconSm } from '@/widgets/components/icon';
import React from 'react';
import { IconButton } from 'rsuite';
import styled from 'styled-components';

const StyledIconButton = styled(IconButton)`
  padding-left: 12px !important;
`;

const CloseIcon = styled(IconSm)`
  color: rgba(0, 0, 0, 0.25);
`;

export function CloseButton(props) {
  return (
    <StyledIconButton
      onClick={props.onClick}
      icon={<CloseIcon icon={closeIcon} />}
      appearance="subtle"
    />
  );
}
